// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3lHOm","box":"WorkspacesBox_box__1esAV","node":"WorkspacesBox_node__3e6dZ"};